const styles = (theme) => ({
  dashboardWrapper: {
    marginInline: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      marginInline: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      marginInline: theme.spacing(1),
    },
  },
  marginAll: {
    marginTop: theme.spacing(11),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(11),
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(10),
    },
  },
});

export default styles;
